module.exports = __webpack_public_path__ + "img/disc-01.aa2f6a2f.svg";